/* SIZE GUIDE — VELO PDP centered modal (<size-guide>).
   Modal open/close, overlay and focus-trap are handled by modal-dialog (modal.js).
   This element only: renders the SIZE CONVERSION data into mobile cards + a
   desktop table, switches tabs, and toggles CM/IN on the (gated) measured
   tables. Vanilla, no dependencies. */
(function () {
  'use strict';

  const UNIT_KEY = 'velo:sizeUnit';

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }
  function $all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  function el(tag, cls, text) {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function readUnit() {
    try {
      return localStorage.getItem(UNIT_KEY) === 'in' ? 'in' : 'cm';
    } catch (e) {
      return 'cm';
    }
  }
  function writeUnit(u) {
    try {
      localStorage.setItem(UNIT_KEY, u);
    } catch (e) {}
  }

  class SizeGuide extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.modal = $('.js-size-guide-modal', this);

      // Parse the verified SIZE CONVERSION data island.
      const raw = $('[data-size-guide-conversion]', this);
      try {
        this.conversion = raw ? JSON.parse(raw.textContent) : [];
      } catch (e) {
        this.conversion = [];
      }

      this.unit = readUnit();

      // All queries that scope to `this` run FIRST so the elements are still
      // descendants of <size-guide> at query time. Moving the modal to <body>
      // happens AFTER render/bind so $(sel, this) scoping doesn't miss them.
      this.renderConversion();
      this.bindTabs();
      this.bindUnits();
      this.syncUnitButtons();

      // Wire external openers anywhere on the page (e.g. the variant-picker
      // "Size guide" link) via a declarative [data-size-guide-open] attribute.
      if (this.modal) {
        $all('[data-size-guide-open]').forEach((trigger) => {
          trigger.addEventListener('click', (e) => {
            e.preventDefault();
            this.modal.open(trigger);
          });
        });
      }

      // Relocate the modal to <body> AFTER renderConversion/bindTabs/bindUnits
      // so that all $(sel, this) scoped queries above have already run. Moving
      // first would make those queries miss the conversion cards and the modal
      // would open EMPTY (this exact bug was hit with the drawer approach).
      // Moving to body lets it escape any ancestor stacking contexts.
      if (this.modal && this.modal.parentNode !== document.body) {
        document.body.appendChild(this.modal);
      }
    }

    /* SIZE CONVERSION: single data source → two presentations.
       Mobile = scroll-snap cards (one size/card); desktop = table. CSS picks. */
    renderConversion() {
      const cards = $('[data-size-guide-cards]', this);
      const rows = $('[data-size-guide-rows]', this);
      if (!this.conversion.length) return;

      if (cards) {
        cards.innerHTML = '';
        this.conversion.forEach((row) => {
          const card = el('div', 'size-guide__card');
          card.appendChild(el('div', 'size-guide__card-letter', row.letter));
          const dl = el('dl', 'size-guide__card-list');
          [['AU', row.au], ['UK', row.uk], ['US', row.us], ['EU', row.eu]].forEach((pair) => {
            dl.appendChild(el('dt', 'size-guide__card-key', pair[0]));
            dl.appendChild(el('dd', 'size-guide__card-val', pair[1]));
          });
          card.appendChild(dl);
          cards.appendChild(card);
        });
      }

      if (rows) {
        rows.innerHTML = '';
        this.conversion.forEach((row) => {
          const tr = document.createElement('tr');
          const th = el('th', null, row.letter);
          th.setAttribute('scope', 'row');
          tr.appendChild(th);
          [row.au, row.uk, row.us, row.eu].forEach((v) => {
            tr.appendChild(el('td', null, v));
          });
          rows.appendChild(tr);
        });
      }
    }

    bindTabs() {
      const tabs = $all('[data-size-guide-tab]', this);
      if (tabs.length < 2) return; // single tab (conversion only) — nothing to switch
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          this.selectTab(tab.getAttribute('data-size-guide-tab'));
        });
      });
    }

    selectTab(name) {
      $all('[data-size-guide-tab]', this).forEach((tab) => {
        const on = tab.getAttribute('data-size-guide-tab') === name;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', String(on));
      });
      $all('[data-size-guide-panel]', this).forEach((panel) => {
        panel.classList.toggle('is-active', panel.getAttribute('data-size-guide-panel') === name);
      });
    }

    /* CM / IN — affects measured tables only (gated off now). Persisted so the
       preference carries over once real measurements ship. */
    bindUnits() {
      $all('[data-size-guide-unit]', this).forEach((btn) => {
        btn.addEventListener('click', () => {
          this.setUnit(btn.getAttribute('data-size-guide-unit'));
        });
      });
    }

    setUnit(unit) {
      this.unit = unit === 'in' ? 'in' : 'cm';
      writeUnit(this.unit);
      this.syncUnitButtons();
    }

    syncUnitButtons() {
      $all('[data-size-guide-unit]', this).forEach((btn) => {
        const on = btn.getAttribute('data-size-guide-unit') === this.unit;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', String(on));
      });
      this.setAttribute('data-unit', this.unit);
    }
  }

  if (!customElements.get('size-guide')) {
    customElements.define('size-guide', SizeGuide);
  }
})();
